var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "cus-chat-supervise"
    },
    [
      _c(
        "div",
        { staticClass: "cus-chat-supervise-search" },
        [
          _c(
            "el-form",
            { staticClass: "form-row", attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "任务名称" } },
                [
                  _c("el-input", {
                    attrs: { size: "mini", clearable: "" },
                    on: { change: _vm.selectBindStatus },
                    model: {
                      value: _vm.formInline.msgName,
                      callback: function($$v) {
                        _vm.$set(_vm.formInline, "msgName", $$v)
                      },
                      expression: "formInline.msgName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "创建时间" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      size: "mini",
                      "picker-options": _vm.pickerOptions
                    },
                    on: { change: _vm.selectBindStatus },
                    model: {
                      value: _vm.date,
                      callback: function($$v) {
                        _vm.date = $$v
                      },
                      expression: "date"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: {
                click: function($event) {
                  return _vm.openPopup("add")
                }
              }
            },
            [_vm._v("新建任务")]
          )
        ],
        1
      ),
      _c(
        "div",
        { ref: "tableWrapper", staticClass: "table-row" },
        [
          _c(
            "el-table",
            {
              ref: "cusChatTable",
              attrs: {
                size: "small",
                data: _vm.tableData,
                fit: "",
                "highlight-current-row": "",
                align: "center",
                "header-cell-style": { background: "#eef1f6" },
                height: _vm.tableHeight
              },
              on: { "selection-change": _vm.handleSelectionChange }
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.getGlobalIndex(scope.$index)) + " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "msgName",
                  label: "任务名称",
                  "show-overflow-tooltip": "",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "content", label: "发送内容", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content: scope.row.content,
                              placement: "top",
                              disabled: !_vm.showTooltip(scope.row.content)
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                ref: "contentCell",
                                staticClass: "content-cell",
                                on: {
                                  mouseover: function($event) {
                                    return _vm.handleMouseOver(scope.$index)
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(scope.row.content) + " ")]
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "executeNum",
                  label: "执行群聊数",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "finishNum", label: "完成数", align: "center" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "unexecuteNum",
                  label: "未完成数",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建人/时间",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.createByName +
                                "/" +
                                scope.row.createTime
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm.isShow
                ? _c("el-table-column", {
                    attrs: {
                      prop: "operation",
                      label: "操作",
                      align: "center",
                      width: "260"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "flex-end"
                                  }
                                },
                                [
                                  scope.row.pushType != 0
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            link: "",
                                            size: "mini"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.openPopup(
                                                "edit",
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("编辑")]
                                      )
                                    : _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            link: "",
                                            size: "mini"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.openPopup(
                                                "details",
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("详情")]
                                      ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        link: "",
                                        size: "mini"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.runRes(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("执行结果")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "danger",
                                        link: "",
                                        size: "mini"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteRow(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      600587603
                    )
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "Pagination-row" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.formInline.page,
              "page-size": _vm.formInline.size,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
              "page-sizes": [20, 50, 100, 200, 500]
            },
            on: {
              "current-change": _vm.changePage,
              "size-change": _vm.changeSize,
              "update:currentPage": function($event) {
                return _vm.$set(_vm.formInline, "page", $event)
              },
              "update:current-page": function($event) {
                return _vm.$set(_vm.formInline, "page", $event)
              },
              "update:pageSize": function($event) {
                return _vm.$set(_vm.formInline, "size", $event)
              },
              "update:page-size": function($event) {
                return _vm.$set(_vm.formInline, "size", $event)
              }
            }
          })
        ],
        1
      ),
      _vm.showAddEditPopup
        ? _c("addEditPopup", {
            attrs: {
              row: _vm.rowPopup,
              dialogVisible: _vm.showAddEditPopup,
              myType: 7,
              currentPopupType: _vm.currentPopupType,
              titleName: _vm.popupTitle
            },
            on: {
              "update:dialogVisible": function($event) {
                _vm.showAddEditPopup = $event
              },
              "update:dialog-visible": function($event) {
                _vm.showAddEditPopup = $event
              },
              getData: _vm.selectBindStatus
            }
          })
        : _vm._e(),
      _vm.showExecutionResPopup
        ? _c("executionResPopup", {
            attrs: {
              dialogVisible: _vm.showExecutionResPopup,
              row: _vm.rowPopup
            },
            on: {
              "update:dialogVisible": function($event) {
                _vm.showExecutionResPopup = $event
              },
              "update:dialog-visible": function($event) {
                _vm.showExecutionResPopup = $event
              },
              openViewPopup: _vm.openViewPopup
            }
          })
        : _vm._e(),
      _vm.showViewChatHistory
        ? _c("viewChatHistory", {
            attrs: {
              dialogVisibleV: _vm.showViewChatHistory,
              row: _vm.currentRow
            },
            on: {
              "update:dialogVisibleV": function($event) {
                _vm.showViewChatHistory = $event
              },
              "update:dialog-visible-v": function($event) {
                _vm.showViewChatHistory = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }